import { defineFieldFormInterface } from "~/entities/field";
import InterfaceDatetimeDatetimeType from "./InterfaceDatetime.vue";

export default defineFieldFormInterface({
  interface: "datetime",
  component: InterfaceDatetimeDatetimeType,
});
